import { JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type Payload = {
  extension: string;
  filename: string;
  mediaID?: string;
  selectedAnimationNumber?: string;
  videoDuration: number;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postProcessMedia(
  jobID: string,
  payload: Payload,
) {
  const res = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    `/jobs/${jobID}/processMedia`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );

  return {
    error: res.error,
    data: transformJob(res.data),
  };
}
